import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_CLIENT_CONFIG } from '../core/api-client-config';
import { AdminAttachment } from '../models';

@Injectable({ providedIn: 'root' })
export class AdminAttachmentsApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = `${inject(API_CLIENT_CONFIG).apiBaseUrl}/api/admin/Attachments`;

  uploadAttachment(
    attachment: File,
  ): Observable<{ url: string; id: string; fileName: string }> {
    const formData = new FormData();
    formData.append('file', attachment);
    formData.append('ContentType', attachment.type);
    formData.append('ContentDisposition', '');
    formData.append('Headers.propertyName*', '');
    formData.append('Length', '1');
    formData.append('Name', attachment.name);
    formData.append('FileName', attachment.name);
    return this.httpClient.post<{ url: string; id: string; fileName: string }>(
      `${this.baseUrl}`,
      formData,
    );
  }

  getAttachment(id: string): Observable<AdminAttachment> {
    return this.httpClient.get<AdminAttachment>(`${this.baseUrl}/${id}`);
    // const attachment = this.mockData.find((att) => att.id === id);
  }

  addAttachment(attachment: {
    tenderId: string;
    attachmentId: string;
  }): Observable<void> {
    return this.httpClient.put<void>(`${this.baseUrl}/tender/add`, attachment);
  }
}
